import React from "react";

type ConfigPageProps = {};

type Config = Omit<NodeJS.ProcessEnv, "">;

const BANNED_KEYS = [
  "NODE_ENV",
  "PUBLIC_URL",
  "WDS_SOCKET_HOST",
  "WDS_SOCKET_PATH",
  "WDS_SOCKET_PORT",
  "FAST_REFRESH",
  "REACT_APP_PASSWORD",
];

const config: Config = Object.keys(process.env).reduce((acc, key) => {
  if (!BANNED_KEYS.includes(key)) {
    acc[key] = process.env[key];
  }
  return acc;
}, {} as Config);

const ConfigPage: React.FC<ConfigPageProps> = () => {
  return (
    <div>
      {Object.keys(config).map((x, i) => {
        return (
          <p key={x}>
            {x}={Object.values(config)[i]}
          </p>
        );
      })}
    </div>
  );
};

export default ConfigPage;